import { render, staticRenderFns } from "./notification-plan.vue?vue&type=template&id=04d4d9bc&scoped=true&"
import script from "./notification-plan.vue?vue&type=script&lang=js&"
export * from "./notification-plan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d4d9bc",
  null
  
)

export default component.exports